import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Building,
  Settings,
  CalendarDays,
  Network,
  ShieldCheck,
  Users2,
} from "lucide-react";

const mainListItems = [
  {
    link: "/home",
    text: "Dashboard",
    icon: <DashboardRoundedIcon size={20} />,
  },
  { link: "/employees", text: "Employees", icon: <Users2 size={20} /> },
  { link: "/department", text: "Department", icon: <Network size={20} /> },
  {
    link: "/software-access",
    text: "Software Access",
    icon: <ShieldCheck size={20} />,
  },
  { link: "/holiday", text: "Holiday", icon: <CalendarDays size={20} /> },
  // {
  //   link: "/organisation",
  //   text: "Organisation",
  //   icon: <Building size={20} />,
  // },
  // { link: "/settings", text: "Settings", icon: <Settings size={20} /> },
];
const secondaryListItems = [
  // { link: "/settings", text: "Settings", icon: <SettingsRoundedIcon /> },
  // { link: "/about", text: "About", icon: <InfoRoundedIcon /> },
  // { link: "/feedback", text: "Feedback", icon: <HelpRoundedIcon /> },
];

export default function MenuContent() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: "space-between" }}>
      <List dense>
        {mainListItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ display: "block" }}>
            <ListItemButton
              selected={location.pathname === item.link}
              onClick={() => navigate(item.link)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText sx={{ fontSize: "18px" }} disableTypography>
                {item.text}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List dense>
        {secondaryListItems.map((item) => (
          <ListItem key={item.text} disablePadding sx={{ display: "block" }}>
            <ListItemButton
              selected={location.pathname === item.link}
              onClick={() => navigate(item.link)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
